import { c as _c } from "react/compiler-runtime";
import { createQueryFn, marketplaceQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getMarketplaceBalance } from '../../../actions/marketplace/getMarketplaceBalance.js';
const fetcher = createQueryFn(getMarketplaceBalance);
const EMPTY_MARKETPLACE_BALANCE = {
  activatedDraws: []
};
/**
 * Gets marketplace balance for a given draw.
 *
 * @param drawNumber Draw number to get marketplace balance for
 * @param product Product to get marketplace balance for
 * @param queryOptions Optional query configuration options
 * @param queryOptions.isEnabled Set to false to resolve an empty balance without calling the server action, e.g. for users without marketplace wallets
 * @returns Marketplace balance model
 */
export function useGetMarketplaceBalance(drawNumber, product, queryOptions) {
  const $ = _c(13);
  let isEnabled;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== drawNumber || $[1] !== product || $[2] !== queryOptions) {
    const {
      isEnabled: t4,
      ...suspenseQueryOptions
    } = queryOptions ?? {};
    isEnabled = t4 === undefined ? true : t4;
    t3 = useSuspenseQuery;
    t0 = suspenseQueryOptions;
    t1 = isEnabled ? marketplaceQueryKeys.marketplaceBalance(product, drawNumber) : marketplaceQueryKeys.marketplaceBalanceSkipped(product, drawNumber);
    t2 = isEnabled ? fetcher({
      defaultValue: suspenseQueryOptions.defaultValue
    }) : _temp;
    $[0] = drawNumber;
    $[1] = product;
    $[2] = queryOptions;
    $[3] = isEnabled;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    isEnabled = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isEnabled || $[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t4 = {
      ...t0,
      queryKey: t1,
      queryFn: t2,
      requiresServerPrefetch: isEnabled
    };
    $[8] = isEnabled;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t3(t4);
}
function _temp() {
  return EMPTY_MARKETPLACE_BALANCE;
}